// How long sign-in waits on the server before it says so. Google or the password check has already
// signed the user in by then; these only bound loading their GeoPlay account (Login.jsx).

// The user record decides where to go, so sign-in waits for it, up to this, then offers Try Again.
export const USER_LOAD_MS = 20000;
// The persisted build check and permissions are reloaded after landing, so sign-in moves on without them.
export const OPTIONAL_LOAD_MS = 8000;
// Past this, "Signing you in…" adds that it is still going.
export const SLOW_SIGN_IN_MS = 10000;

export class SignInTimeoutError extends Error {
    constructor() {
        super('Sign-in took too long');
        this.name = 'SignInTimeoutError';
    }
}

/** The promise, or a SignInTimeoutError once ms pass first. The request itself is left to finish or fail. */
export const withinTime = (promise, ms) => {
    let timer;
    const timeout = new Promise((_, reject) => {
        timer = setTimeout(() => reject(new SignInTimeoutError()), ms);
    });
    return Promise.race([promise, timeout]).finally(() => clearTimeout(timer));
};
